import { combineReducers } from 'redux';
import { createReducer } from 'redux-act';
import { createSelector } from 'reselect';
import { createResource } from '@gandi/resource/redux';
import { EMPTY_ARRAY } from '../constants';
import { hashObject } from '../utils';
export const DEFAULT_PAGE = 1;
export const DEFAULT_PER_PAGE = 500;
export const defaultParams = {
  page: DEFAULT_PAGE,
  per_page: DEFAULT_PER_PAGE
};
export const computeLabel = params => hashObject({
  ...defaultParams,
  ...params
});
export const organizationsResource = createResource('gandiReduxOrganization.organizations');
export const fetchOrganizationsList = (params = {}, options = {}) => dispatch => dispatch(organizationsResource.fetch('/organization/organizations', {
  label: computeLabel(params),
  params: {
    ...defaultParams,
    ...params
  },
  on200: response => response,
  not200: response => Promise.reject(response),
  ...options
}));
export const fetchOneOrganization = orgId => dispatch => dispatch(organizationsResource.fetchOne(`/organization/organizations/${orgId}`, {
  label: orgId,
  on200: response => response,
  not200: response => Promise.reject(response)
}));
export const createOneOrganization = (body, options = {}) => dispatch => {
  const dryrun = Number(options.dryrun || false);
  const headers = {
    'Dry-Run': dryrun
  };
  const handlers = {};
  const failure = response => Promise.reject(response);
  if (dryrun) {
    handlers.on200 = response => {
      if (Array.isArray(response.data.errors)) {
        return Promise.reject(response);
      }
      return Promise.resolve(response);
    };
    handlers.not200 = failure;
  } else {
    handlers.on201 = response => Promise.resolve(response);
    handlers.not201 = failure;
  }
  return dispatch(organizationsResource.createOne('/organization/organizations', body, {
    headers,
    ...handlers
  }));
};
export const patchOneOrganization = (id, body, options = {}) => dispatch => {
  const dryrun = Number(options.dryrun || false);
  const headers = {
    'Dry-Run': dryrun
  };
  const handlers = {};
  const failure = response => Promise.reject(response);
  if (dryrun) {
    handlers.on200 = response => {
      if (Array.isArray(response.data.errors)) {
        return Promise.reject(response);
      }
      return Promise.resolve(response);
    };
    handlers.not200 = failure;
  } else {
    handlers.on202 = response => Promise.resolve(response);
    handlers.not202 = failure;
  }
  return dispatch(organizationsResource.patchOne(`/organization/organizations/${id}`, body, {
    headers,
    ...handlers
  }));
};
export const selectComputedLabel = (_, params) => computeLabel(params);
export const selectRawState = state => state.gandiReduxOrganization.organizations;
export const selectOrganizationsList = createSelector([selectRawState, selectComputedLabel], (raw, label) => raw.list[label] || EMPTY_ARRAY);
export const selectOrganizationsListCount = createSelector([selectRawState], raw => raw.list.count);
export const selectIsFetchingOrganizations = (state, props) => organizationsResource.selectIsFetching(state, computeLabel(props));
export const selectIsLoadedOrganizations = (state, props) => organizationsResource.selectIsLoaded(state, computeLabel(props));
export const selectIsFailureOrganizations = (state, props) => organizationsResource.selectIsFailure(state, computeLabel(props));
export const selectIsToRefetchOrganizations = (state, props) => organizationsResource.selectIsToRefetch(state, computeLabel(props));
export const selectIsFetchingOneOrganization = organizationsResource.selectIsFetchingOne;
export const selectIsLoadedOneOrganization = organizationsResource.selectIsLoadedOne;
export const selectIsFailureOneOrganization = organizationsResource.selectIsFailureOne;
export const selectIsToRefetchOneOrganization = organizationsResource.selectIsToRefetchOne;
export const selectOneOrganization = (state, orgId) => selectRawState(state).detail[orgId];
export const fetchOrganizationsListHandler = (state, {
  label,
  response
}) => {
  const organizationsList = response.data.reduce((acc, organization) => [...acc, organization], []);
  return {
    ...state,
    count: parseInt(response.headers.get('X-total-count'), 10),
    [label]: organizationsList
  };
};
export const fetchOneOrganizationHandler = (state, {
  response
}) => ({
  ...state,
  [response.data.id]: response.data
});
export const listInitialState = {
  count: 0
};
export const listReducer = createReducer({
  [organizationsResource.fetch.success.getType()]: fetchOrganizationsListHandler
}, listInitialState);
export const detailInitialState = {};
export const detailReducer = createReducer({
  [organizationsResource.fetchOne.success.getType()]: fetchOneOrganizationHandler
}, detailInitialState);
export const reducer = combineReducers({
  list: listReducer,
  detail: detailReducer
});
export default reducer;